import { SectionHeader, SelectableBoxField, useScrollOnMount } from '@flos/react-ui';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useResourceBundle } from '../contexts/ResourceContext';
import { navigationActions } from '../store/navigation.slice';
import { ClaimType, Selection } from '../store/navigation.type';
import { IState } from '../types';
import CallYou from './CallYou';
import ClaimComment from './ClaimComment';
import Confirmation from './Confirmation';

const subCategoryUi: {
  [key in ClaimType]: { label: string } | undefined;
} = {
  CLAIMS_CONTENT: {
    label: 'label.category.injury.button.content',
  },
  CLAIMS_AUTO: {
    label: 'label.category.injury.button.auto',
  },
  CLAIMS_BUILDING: {
    label: 'label.category.injury.button.building',
  },
  CLAIMS_PERSONAL: {
    label: 'label.category.injury.button.accident',
  },
  CLAIMS_ANIMAL: {
    label: 'label.category.injury.button.animal',
  },
  CLAIMS_TRAVEL: {
    label: 'label.category.injury.button.travel',
  },
  CLAIMS_OTHER: {
    label: 'label.category.injury.button.others',
  },
};

const ClaimTopic = () => {
  const scrollTarget = useScrollOnMount<HTMLDivElement>({ behavior: 'smooth' });
  const dispatch = useDispatch();
  const claim = useSelector<IState, Selection<'injury'>>((state) => state.navigation.selections.injury);
  const resource = useResourceBundle();

  const options = useMemo(
    () =>
      Object.entries(subCategoryUi)
        .filter(([, value]) => value !== undefined)
        .map(([key, obj]) => {
          const value = obj as NonNullable<typeof obj>;
          return { label: resource[value.label], value: key };
        }),
    [resource]
  );
  const select = (name: string) => {
    dispatch(navigationActions.selectClaimCategory(name as ClaimType));
  };

  return (
    <div className="u-Space-up--lg" ref={scrollTarget}>
      <SectionHeader title={resource['label.category.injury.header']} />
      <SelectableBoxField options={options} value={claim.category ?? ''} onChangeValue={select} maxWidth="wide" />
      {claim.category ? (
        <>
          {claim.category === 'CLAIMS_OTHER' && <ClaimComment />}
          <>
            <CallYou />
            <Confirmation />
          </>
        </>
      ) : null}
    </div>
  );
};

export default ClaimTopic;
